import { createSlice } from "@reduxjs/toolkit"

// Définition de l'état initial
const initialState = {
  layoutType: "horizontal", // ou un autre type si nécessaire
  layoutWidth: "fluid", // ou "boxed"
  leftSideBarTheme: "dark", // ou "light"
  bodyTheme: "light", // ou "dark"
  bodyMode: "rtl", // ou "ltr"
  leftSideBarType: "default", // ou d'autres types possibles
  topbarTheme: "light", // ou "dark"
  showRightSidebar: false,
  isMobile: false,
  showSidebar: true,
  leftMenu: false,
}

// Création du slice
const layoutSlice = createSlice({
  name: "layout",
  initialState,
  reducers: {
    changeLayout: (state, action) => {
      state.layoutType = action.payload
      if (action.payload === "horizontal") {
        state.topbarTheme = "dark"
        document.body.removeAttribute("data-sidebar")
        document.body.removeAttribute("data-sidebar-size")
      } else {
        state.topbarTheme = "light"
      }
      document.body.setAttribute("data-layout", action.payload)
    },
    changeLayoutWidth: (state, action) => {
      state.layoutWidth = action.payload
      if (action.payload === "boxed") {
        state.leftSideBarType = "icon"
        document.body.setAttribute("data-layout-size", "boxed")
      } else {
        state.leftSideBarType = "default"
        document.body.setAttribute("data-layout-size", "fluid")
      }
    },
    changeSidebarTheme: (state, action) => {
      state.leftSideBarTheme = action.payload
      document.body.setAttribute("data-sidebar", action.payload)
    },
    changeBodyTheme: (state, action) => {
      state.bodyTheme = action.payload
      document.body.setAttribute("data-bs-theme", action.payload)
    },
    changeBodyMode: (state, action) => {
      state.bodyMode = action.payload
      document.body.setAttribute("data-mode", action.payload)
    },
    changeSidebarType: (state, action) => {
      const { sidebarType, isMobile } = action.payload
      state.leftSideBarType = sidebarType

      switch (sidebarType) {
        case "compact":
          document.body.setAttribute("data-sidebar-size", "small")
          document.body.classList.remove("sidebar-enable", "vertical-collpsed")
          break
        case "icon":
          document.body.setAttribute("data-keep-enlarged", "true")
          document.body.classList.add("vertical-collpsed")
          break
        case "condensed":
          document.body.classList.add("sidebar-enable")
          if (window.screen.width >= 992) {
            document.body.classList.add("vertical-collpsed")
          }
          break
        default:
          document.body.removeAttribute("data-sidebar-size")
          document.body.classList.remove("sidebar-enable", "vertical-collpsed")
          break
      }
    },
    changeTopbarTheme: (state, action) => {
      state.topbarTheme = action.payload
      document.body.setAttribute("data-topbar", action.payload)
    },
    showRightSidebar: (state, action) => {
      state.showRightSidebar = action.payload
      if (action.payload) {
        document.body.classList.add("right-bar-enabled")
      } else {
        document.body.classList.remove("right-bar-enabled")
      }
    },
    showSidebar: (state, action) => {
      state.showSidebar = action.payload
    },
    toggleLeftMenu: (state, action) => {
      state.leftMenu = action.payload
    },
  },
})

// Export des actions
export const {
  changeLayout,
  changeLayoutWidth,
  changeSidebarTheme,
  changeBodyTheme,
  changeBodyMode,
  changeSidebarType,
  changeTopbarTheme,
  showRightSidebar,
  showSidebar,
  toggleLeftMenu,
} = layoutSlice.actions

// Export du reducer
export default layoutSlice.reducer
